// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1OSU5","error":"Textarea_error__2nQno","readonly":"Textarea_readonly__2XzLq","disabled":"Textarea_disabled__1inZJ"};